export const scWalletAave = [
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: 'address',
        name: 'token',
        type: 'address'
      },
      {
        indexed: false,
        internalType: 'uint256',
        name: 'tokenAmt',
        type: 'uint256'
      },
      {
        indexed: true,
        internalType: 'uint256',
        name: 'rateMode',
        type: 'uint256'
      },
      {
        indexed: false,
        internalType: 'uint256',
        name: 'getId',
        type: 'uint256'
      },
      {
        indexed: false,
        internalType: 'uint256',
        name: 'setId',
        type: 'uint256'
      }
    ],
    name: 'LogBorrow',
    type: 'event'
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: 'address',
        name: 'token',
        type: 'address'
      },
      {
        indexed: false,
        internalType: 'uint256',
        name: 'amt',
        type: 'uint256'
      },
      {
        indexed: false,
        internalType: 'uint256',
        name: 'rateMode',
        type: 'uint256'
      },
      {
        indexed: false,
        internalType: 'address',
        name: 'onBehalfOf',
        type: 'address'
      },
      {
        indexed: false,
        internalType: 'uint256',
        name: 'getId',
        type: 'uint256'
      },
      {
        indexed: false,
        internalType: 'uint256',
        name: 'setId',
        type: 'uint256'
      }
    ],
    name: 'LogBorrowOnBehalfOf',
    type: 'event'
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: 'address',
        name: 'token',
        type: 'address'
      },
      {
        indexed: false,
        internalType: 'uint256',
        name: 'amount',
        type: 'uint256'
      },
      {
        indexed: false,
        internalType: 'uint256',
        name: 'rateMode',
        type: 'uint256'
      },
      {
        indexed: false,
        internalType: 'address',
        name: 'delegateTo',
        type: 'address'
      },
      {
        indexed: false,
        internalType: 'uint256',
        name: 'getId',
        type: 'uint256'
      },
      {
        indexed: false,
        internalType: 'uint256',
        name: 'setId',
        type: 'uint256'
      }
    ],
    name: 'LogDelegateBorrow',
    type: 'event'
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: 'address',
        name: 'token',
        type: 'address'
      },
      {
        indexed: false,
        internalType: 'uint256',
        name: 'tokenAmt',
        type: 'uint256'
      },
      {
        indexed: false,
        internalType: 'uint256',
        name: 'getId',
        type: 'uint256'
      },
      {
        indexed: false,
        internalType: 'uint256',
        name: 'setId',
        type: 'uint256'
      }
    ],
    name: 'LogDeposit',
    type: 'event'
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: 'address',
        name: 'token',
        type: 'address'
      },
      {
        indexed: false,
        internalType: 'uint256',
        name: 'amt',
        type: 'uint256'
      },
      {
        indexed: false,
        internalType: 'uint256',
        name: 'getId',
        type: 'uint256'
      },
      {
        indexed: false,
        internalType: 'uint256',
        name: 'setId',
        type: 'uint256'
      }
    ],
    name: 'LogDepositWithoutCollateral',
    type: 'event'
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: 'address[]',
        name: 'tokens',
        type: 'address[]'
      }
    ],
    name: 'LogDisableCollateral',
    type: 'event'
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: 'address[]',
        name: 'tokens',
        type: 'address[]'
      }
    ],
    name: 'LogEnableCollateral',
    type: 'event'
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: 'address',
        name: 'token',
        type: 'address'
      },
      {
        indexed: false,
        internalType: 'uint256',
        name: 'tokenAmt',
        type: 'uint256'
      },
      {
        indexed: true,
        internalType: 'uint256',
        name: 'rateMode',
        type: 'uint256'
      },
      {
        indexed: false,
        internalType: 'uint256',
        name: 'getId',
        type: 'uint256'
      },
      {
        indexed: false,
        internalType: 'uint256',
        name: 'setId',
        type: 'uint256'
      }
    ],
    name: 'LogPayback',
    type: 'event'
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: 'address',
        name: 'token',
        type: 'address'
      },
      {
        indexed: false,
        internalType: 'uint256',
        name: 'amt',
        type: 'uint256'
      },
      {
        indexed: false,
        internalType: 'uint256',
        name: 'rateMode',
        type: 'uint256'
      },
      {
        indexed: false,
        internalType: 'address',
        name: 'onBehalfOf',
        type: 'address'
      },
      {
        indexed: false,
        internalType: 'uint256',
        name: 'getId',
        type: 'uint256'
      },
      {
        indexed: false,
        internalType: 'uint256',
        name: 'setId',
        type: 'uint256'
      }
    ],
    name: 'LogPaybackOnBehalfOf',
    type: 'event'
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: 'uint8',
        name: 'categoryId',
        type: 'uint8'
      }
    ],
    name: 'LogSetUserEMode',
    type: 'event'
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: 'address',
        name: 'token',
        type: 'address'
      },
      {
        indexed: false,
        internalType: 'uint256',
        name: 'rateMode',
        type: 'uint256'
      }
    ],
    name: 'LogSwapRateMode',
    type: 'event'
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: 'address',
        name: 'token',
        type: 'address'
      },
      {
        indexed: false,
        internalType: 'uint256',
        name: 'tokenAmt',
        type: 'uint256'
      },
      {
        indexed: false,
        internalType: 'uint256',
        name: 'getId',
        type: 'uint256'
      },
      {
        indexed: false,
        internalType: 'uint256',
        name: 'setId',
        type: 'uint256'
      }
    ],
    name: 'LogWithdraw',
    type: 'event'
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: 'token',
        type: 'address'
      },
      {
        internalType: 'uint256',
        name: 'amt',
        type: 'uint256'
      },
      {
        internalType: 'uint256',
        name: 'rateMode',
        type: 'uint256'
      },
      {
        internalType: 'uint256',
        name: 'getId',
        type: 'uint256'
      },
      {
        internalType: 'uint256',
        name: 'setId',
        type: 'uint256'
      }
    ],
    name: 'borrow',
    outputs: [
      {
        internalType: 'string',
        name: '_eventName',
        type: 'string'
      },
      {
        internalType: 'bytes',
        name: '_eventParam',
        type: 'bytes'
      }
    ],
    stateMutability: 'payable',
    type: 'function'
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: 'token',
        type: 'address'
      },
      {
        internalType: 'uint256',
        name: 'amt',
        type: 'uint256'
      },
      {
        internalType: 'uint256',
        name: 'rateMode',
        type: 'uint256'
      },
      {
        internalType: 'address',
        name: 'onBehalfOf',
        type: 'address'
      },
      {
        internalType: 'uint256',
        name: 'getId',
        type: 'uint256'
      },
      {
        internalType: 'uint256',
        name: 'setId',
        type: 'uint256'
      }
    ],
    name: 'borrowOnBehalfOf',
    outputs: [
      {
        internalType: 'string',
        name: '_eventName',
        type: 'string'
      },
      {
        internalType: 'bytes',
        name: '_eventParam',
        type: 'bytes'
      }
    ],
    stateMutability: 'payable',
    type: 'function'
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: 'token',
        type: 'address'
      },
      {
        internalType: 'uint256',
        name: 'amount',
        type: 'uint256'
      },
      {
        internalType: 'uint256',
        name: 'rateMode',
        type: 'uint256'
      },
      {
        internalType: 'address',
        name: 'delegateTo',
        type: 'address'
      },
      {
        internalType: 'uint256',
        name: 'getId',
        type: 'uint256'
      },
      {
        internalType: 'uint256',
        name: 'setId',
        type: 'uint256'
      }
    ],
    name: 'delegateBorrow',
    outputs: [
      {
        internalType: 'string',
        name: '_eventName',
        type: 'string'
      },
      {
        internalType: 'bytes',
        name: '_eventParam',
        type: 'bytes'
      }
    ],
    stateMutability: 'payable',
    type: 'function'
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: 'token',
        type: 'address'
      },
      {
        internalType: 'uint256',
        name: 'amt',
        type: 'uint256'
      },
      {
        internalType: 'uint256',
        name: 'getId',
        type: 'uint256'
      },
      {
        internalType: 'uint256',
        name: 'setId',
        type: 'uint256'
      }
    ],
    name: 'deposit',
    outputs: [
      {
        internalType: 'string',
        name: '_eventName',
        type: 'string'
      },
      {
        internalType: 'bytes',
        name: '_eventParam',
        type: 'bytes'
      }
    ],
    stateMutability: 'payable',
    type: 'function'
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: 'token',
        type: 'address'
      },
      {
        internalType: 'uint256',
        name: 'amt',
        type: 'uint256'
      },
      {
        internalType: 'uint256',
        name: 'getId',
        type: 'uint256'
      },
      {
        internalType: 'uint256',
        name: 'setId',
        type: 'uint256'
      }
    ],
    name: 'depositWithoutCollateral',
    outputs: [
      {
        internalType: 'string',
        name: '_eventName',
        type: 'string'
      },
      {
        internalType: 'bytes',
        name: '_eventParam',
        type: 'bytes'
      }
    ],
    stateMutability: 'payable',
    type: 'function'
  },
  {
    inputs: [
      {
        internalType: 'address[]',
        name: 'tokens',
        type: 'address[]'
      }
    ],
    name: 'disableCollateral',
    outputs: [
      {
        internalType: 'string',
        name: '_eventName',
        type: 'string'
      },
      {
        internalType: 'bytes',
        name: '_eventParam',
        type: 'bytes'
      }
    ],
    stateMutability: 'payable',
    type: 'function'
  },
  {
    inputs: [
      {
        internalType: 'address[]',
        name: 'tokens',
        type: 'address[]'
      }
    ],
    name: 'enableCollateral',
    outputs: [
      {
        internalType: 'string',
        name: '_eventName',
        type: 'string'
      },
      {
        internalType: 'bytes',
        name: '_eventParam',
        type: 'bytes'
      }
    ],
    stateMutability: 'payable',
    type: 'function'
  },
  {
    inputs: [],
    name: 'name',
    outputs: [
      {
        internalType: 'string',
        name: '',
        type: 'string'
      }
    ],
    stateMutability: 'view',
    type: 'function'
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: 'token',
        type: 'address'
      },
      {
        internalType: 'uint256',
        name: 'amt',
        type: 'uint256'
      },
      {
        internalType: 'uint256',
        name: 'rateMode',
        type: 'uint256'
      },
      {
        internalType: 'uint256',
        name: 'getId',
        type: 'uint256'
      },
      {
        internalType: 'uint256',
        name: 'setId',
        type: 'uint256'
      }
    ],
    name: 'payback',
    outputs: [
      {
        internalType: 'string',
        name: '_eventName',
        type: 'string'
      },
      {
        internalType: 'bytes',
        name: '_eventParam',
        type: 'bytes'
      }
    ],
    stateMutability: 'payable',
    type: 'function'
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: 'token',
        type: 'address'
      },
      {
        internalType: 'uint256',
        name: 'amt',
        type: 'uint256'
      },
      {
        internalType: 'uint256',
        name: 'rateMode',
        type: 'uint256'
      },
      {
        internalType: 'address',
        name: 'onBehalfOf',
        type: 'address'
      },
      {
        internalType: 'uint256',
        name: 'getId',
        type: 'uint256'
      },
      {
        internalType: 'uint256',
        name: 'setId',
        type: 'uint256'
      }
    ],
    name: 'paybackOnBehalfOf',
    outputs: [
      {
        internalType: 'string',
        name: '_eventName',
        type: 'string'
      },
      {
        internalType: 'bytes',
        name: '_eventParam',
        type: 'bytes'
      }
    ],
    stateMutability: 'payable',
    type: 'function'
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: 'token',
        type: 'address'
      },
      {
        internalType: 'uint256',
        name: 'amt',
        type: 'uint256'
      },
      {
        internalType: 'uint256',
        name: 'rateMode',
        type: 'uint256'
      },
      {
        internalType: 'uint256',
        name: 'getId',
        type: 'uint256'
      },
      {
        internalType: 'uint256',
        name: 'setId',
        type: 'uint256'
      }
    ],
    name: 'paybackWithATokens',
    outputs: [
      {
        internalType: 'string',
        name: '_eventName',
        type: 'string'
      },
      {
        internalType: 'bytes',
        name: '_eventParam',
        type: 'bytes'
      }
    ],
    stateMutability: 'payable',
    type: 'function'
  },
  {
    inputs: [
      {
        internalType: 'uint8',
        name: 'categoryId',
        type: 'uint8'
      }
    ],
    name: 'setUserEMode',
    outputs: [
      {
        internalType: 'string',
        name: '_eventName',
        type: 'string'
      },
      {
        internalType: 'bytes',
        name: '_eventParam',
        type: 'bytes'
      }
    ],
    stateMutability: 'nonpayable',
    type: 'function'
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: 'token',
        type: 'address'
      },
      {
        internalType: 'uint256',
        name: 'rateMode',
        type: 'uint256'
      }
    ],
    name: 'swapBorrowRateMode',
    outputs: [
      {
        internalType: 'string',
        name: '_eventName',
        type: 'string'
      },
      {
        internalType: 'bytes',
        name: '_eventParam',
        type: 'bytes'
      }
    ],
    stateMutability: 'payable',
    type: 'function'
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: 'token',
        type: 'address'
      },
      {
        internalType: 'uint256',
        name: 'amt',
        type: 'uint256'
      },
      {
        internalType: 'uint256',
        name: 'getId',
        type: 'uint256'
      },
      {
        internalType: 'uint256',
        name: 'setId',
        type: 'uint256'
      }
    ],
    name: 'withdraw',
    outputs: [
      {
        internalType: 'string',
        name: '_eventName',
        type: 'string'
      },
      {
        internalType: 'bytes',
        name: '_eventParam',
        type: 'bytes'
      }
    ],
    stateMutability: 'payable',
    type: 'function'
  }
];